import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "stats__item" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "stats__separator" }, "-", -1)
const _hoisted_3 = { class: "stats__item" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "stats__separator" }, "-", -1)
const _hoisted_5 = { class: "stats__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconMobility = _resolveComponent("IconMobility")!
  const _component_IconBase = _resolveComponent("IconBase")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["stats__wrapper", { build: _ctx.source === 'build' }])
  }, [
    _createElementVNode("span", _hoisted_1, [
      _createVNode(_component_IconBase, {
        iconColor: _ctx.source === 'build' ? '#94FF94' : 'currentcolor',
        width: _ctx.size === 'normal' ? 16 : 14,
        height: _ctx.size === 'normal' ? 16 : 14
      }, {
        default: _withCtx(() => [
          _createVNode(_component_IconMobility)
        ]),
        _: 1
      }, 8, ["iconColor", "width", "height"]),
      _createTextVNode(" " + _toDisplayString(_ctx.stats[0] != null ? _ctx.stats[0] : '—'), 1)
    ]),
    _hoisted_2,
    _createElementVNode("span", _hoisted_3, [
      _createVNode(_component_IconBase, {
        iconColor: _ctx.source === 'build' ? '#FF9494' : 'currentcolor',
        width: _ctx.size === 'normal' ? 16 : 14,
        height: _ctx.size === 'normal' ? 16 : 14
      }, {
        default: _withCtx(() => [
          _createVNode(_component_IconMobility)
        ]),
        _: 1
      }, 8, ["iconColor", "width", "height"]),
      _createTextVNode(" " + _toDisplayString(_ctx.stats[1] != null ? _ctx.stats[1] : '—'), 1)
    ]),
    _hoisted_4,
    _createElementVNode("span", _hoisted_5, [
      _createVNode(_component_IconBase, {
        iconColor: _ctx.source === 'build' ? '#FFFF94' : 'currentcolor',
        width: _ctx.size === 'normal' ? 16 : 14,
        height: _ctx.size === 'normal' ? 16 : 14
      }, {
        default: _withCtx(() => [
          _createVNode(_component_IconMobility)
        ]),
        _: 1
      }, 8, ["iconColor", "width", "height"]),
      _createTextVNode(" " + _toDisplayString(_ctx.stats[2] != null ? _ctx.stats[2] : '—'), 1)
    ])
  ], 2))
}